export function deleteDuplicates<T>(arr: T[], callback: (item: T) => unknown) {
  const seen = new Set();

  return arr.filter((item) => {
    const key = callback(item);

    // Duplicate, filter out
    if (seen.has(key)) return false;

    // First, keep it
    seen.add(key);
    return true;
  });
}
